import { createStyles, Theme } from '@material-ui/core';

export const styles = (theme: Theme) =>
  createStyles({
    cardTitle: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      marginBottom: theme.spacing(2),
      '&>h1': {
        paddingRight: theme.spacing(2)
      }
    },
    cardAction: {
      marginLeft: 'auto'
    },
    resume: {
      '& > *': {
        display: 'table'
      }
    }
  });
